import { render, staticRenderFns } from "./Scripts.vue?vue&type=template&id=12e20f7c&"
import script from "./Scripts.vue?vue&type=script&lang=js&"
export * from "./Scripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports